import { z } from 'zod'
import { permissionSchema } from './permission'
import { roleSchema } from './role'
import { timezoneSchema } from '@/lib/schema/v1/timezone'
import { notificationSettingsSchema } from '@/lib/schema/v1/notification-setting'

export const userSchema = z
    .object({
        email: z.string().nullish(),
        first_name: z.string().nullish(),
        full_name: z.string().nullish(),
        is_active: z.boolean().nullish(),
        is_super_admin: z.boolean().nullish(),
        last_name: z.string().nullish(),
        locale: z.string().nullish(),
        name_initial: z.string().nullish(),
        notification_settings: notificationSettingsSchema.nullish(),
        permissions: z.array(permissionSchema).nullish(),
        profile_photo_url: z.string().url().nullish(),
        roles: z.array(roleSchema).nullable(),
        roles_for_human: z.string().nullish(),
        timezone: timezoneSchema.nullish(),
        timezone_uuid: z.string().uuid().nullish(),
        username: z.string().nullish(),
        uuid: z.string().uuid().nullish(),
    })
    .nullable()

export const usersSchema = z.array(userSchema)

export const userUpdateFormSchema = z.object({
    first_name: z.string().min(1, {
        message: 'First name is required.',
    }),
    last_name: z.string().min(1, {
        message: 'Last name is required.',
    }),
    email: z.string().email().min(1, {
        message: 'Email is required.',
    }),
    username: z.string().min(1, {
        message: 'Username is required.',
    }),
    timezone_uuid: z.string().min(1, {
        message: 'Timezone is required.',
    }),
})

export const userUpdatePasswordFormSchema = z.object({
    current_password: z.string().min(1, {
        message: 'Current password is required.',
    }),
    new_password: z.string().min(1, {
        message: 'New password is required.',
    }),
})

export type User = z.infer<typeof userSchema>
export type UserUpdateForm = z.infer<typeof userUpdateFormSchema>
export type UserUpdatePasswordForm = z.infer<typeof userUpdatePasswordFormSchema>
